var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1374 0.200806C14.2171 0.200806 9.49833 2.15539 6.01915 5.63457C2.53997 9.11375 0.585389 13.8325 0.585388 18.7528C0.585388 23.6731 2.53997 28.3919 6.01915 31.8711C9.49833 35.3503 14.2171 37.3049 19.1374 37.3049L19.1374 18.7528V0.200806Z",
    fill: "#036185"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1374 37.3049C24.0577 37.3049 28.7765 35.3503 32.2557 31.8712C35.7348 28.392 37.6894 23.6732 37.6894 18.7529C37.6894 13.8326 35.7348 9.11382 32.2557 5.63464C28.7765 2.15546 24.0577 0.200869 19.1374 0.200869L19.1374 18.7529L19.1374 37.3049Z",
    fill: "#64BCD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicSub);
export default __webpack_public_path__ + "static/media/BasicSub.65e6daaafe7a241ecff6f2577a3bd319.svg";
export { ForwardRef as ReactComponent };